<template>
    <div class="container-fluid">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <!-- TITLE -->
            <div class="mt-2 tabName">
                <h3>{{ pharmacy ? `${$t(pharmacy.information.center_type)}: ${pharmacy.information.name}` : '' }}</h3>
            </div>
            <div class="alert alert-success" v-show="success" role="alert">{{ $t('saved') }} !</div>
            <!-- PHARMACY INFO -->
            <BasicInfo v-bind:pharmacy="pharmacy" v-bind:pharmacyWebUsers="pharmacyWebUsers" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Loading from '@/views/partial/Loading';
import { getPharmacy, getWebUsersForPharmacy, handleAxiosError } from '@/services/axiosService';
import BasicInfo from './BasicInfo';

export default {
    components: {
        Loading,
        BasicInfo
    },
    data() {
        return {
            error: false,
            loaded: false,
            pharmacy: null,
            pharmacyWebUsers: null,
            prev_locker: '0',
            searchName: '',
            success: false
        };
    },
    async created() {
        // get pharmacy and its web users
        await this.getPharmacy();
        if (!this.error) {
            await this.getWebUsersForPharmacy();
        }
        this.setLoaded();
    },
    computed: {
        ...mapState('account', ['user'])
    },
    methods: {
        ...mapActions('account', [, 'logout']),
        // get pharmacy
        async getPharmacy() {
            try {
                this.pharmacy = await getPharmacy(this.user.pharmacy_id);
                this.pharmacy.box[0].splice(0, 1); // format locker structure variable
            } catch (error) {
                handleAxiosError(error);
                this.error = true;
            }
        },
        // get web users for pharmacy
        async getWebUsersForPharmacy() {
            try {
                this.pharmacyWebUsers = await getWebUsersForPharmacy(this.pharmacy.id);
            } catch (error) {
                handleAxiosError(error);
                this.error = true;
            }
        },
        // set "page loaded"
        setLoaded() {
            if (!this.error) {
                this.loaded = true;
            }
        }
    }
};
</script>
